import { createServerFn } from "@tanstack/react-start";
import { getCookie } from "@tanstack/react-start/server";

export const getDefaultAppearance = createServerFn().handler(
	(): "light" | "dark" => {
		const defaultAppearance = getCookie("APPEARANCE");

		return defaultAppearance === "light" || defaultAppearance === "dark"
			? defaultAppearance
			: "light";
	},
);
